"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var ThumbUp = function ThumbUp(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M11.6667 14H5V5.33329L9.66667 0.666626L10.5 1.49996C10.5778 1.57774 10.6417 1.68329 10.6917 1.81663C10.7417 1.94996 10.7667 2.07774 10.7667 2.19996V2.43329L10.0333 5.33329H13.6667C14.0222 5.33329 14.3333 5.46663 14.6 5.73329C14.8667 5.99996 15 6.31107 15 6.66663V7.99996C15 8.07774 14.9917 8.16107 14.975 8.24996C14.9583 8.33885 14.9333 8.42218 14.9 8.49996L12.9 13.2C12.8 13.4222 12.6333 13.6111 12.4 13.7666C12.1667 13.9222 11.9222 14 11.6667 14ZM3.66667 5.33329V14H1V5.33329H3.66667Z"
  }));
};

var _default = ThumbUp;
exports.default = _default;